import { ReactNode } from 'react';
import { FlowHydrationProvider } from '@adv-frontend/modules-flow';

/**
 * Компонент-обертка, предоставляющий необходимые провайдеры для рендера модулей.
 *
 * @param props - Параметры компонента
 * @returns React-элемент с провайдерами модулей
 */
export function ModulesProviders(props: { children: ReactNode }) {
    return <FlowHydrationProvider>{props.children}</FlowHydrationProvider>;
}
